import * as React from 'react'
// libs
import styled from 'styled-components'
import { useQuery } from '@apollo/client/react'
// view components
import RiskView from 'containers/Risks/RiskView'
// components
import { Header } from 'components/Modals/PlanItems/styles'
import { DrawerModal, LoaderWithOverlay } from 'components/UI'
// view components
import AddRiskViewDrawer from 'components/Modals/RiskViewModal'
// hooks
import { useModalData } from 'hooks/index'
// graphql
import { RISK_VIEWS_QUERY } from 'graphql/risk/queries'
// types
import { Modals } from 'constants/index'
import { IFieldLinkSettings, IRiskView } from 'types/graphql'
// icons
import { CloseIcon } from 'components/UI/Icons'
// context
import { RiskRegisterContext } from 'containers/Risks/RisksRegister/layers'
// views
import { RiskViewWrapper } from 'components/PageComponents/Risks/Register/components/RiskView/views'
// utils
import get from 'lodash/get'

const Wrapper = styled.div`
  height: calc(100% - 64px);

  ${RiskViewWrapper} {
    min-width: unset;
    max-width: unset;
    height: 100%;
    width: 100%;
  }
`

const WRAPPER_STYLES = { height: '100vh', marginLeft: 72 }

const LinkedFormViewModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, riskViewId, isLinking }
  } = useModalData<{ riskViewId: string; isLinking: boolean; linkingSettings: IFieldLinkSettings }>({
    modalType: Modals.LINKED_FORM_VIEW_MODAL
  })

  const [riskView, setRiskView] = React.useState<IRiskView | null>(null)

  const { data, loading } = useQuery(RISK_VIEWS_QUERY, {
    fetchPolicy: 'no-cache',
    skip: !riskViewId,
    variables: { filter: { ids: [riskViewId] } }
  })

  React.useEffect(() => {
    if (!data) return

    const riskView: IRiskView = get(data, 'riskViews.data[0]')

    setRiskView(riskView)
  }, [data])

  return (
    <DrawerModal
      width='calc(100vw - 72px)'
      isOpen={isOpen}
      hideModal={hideModal}
      anchor='bottom'
      contentWrapperStyles={WRAPPER_STYLES}
      data-testid='linked-form-view-drawer'>
      <Header>
        {isLinking ? 'Searching...' : 'Update Search View'}
        <CloseIcon data-testid='linked-form-view-close' onClick={hideModal} />
      </Header>
      <Wrapper>
        {!riskView || loading ? (
          <LoaderWithOverlay isLoading />
        ) : (
          <RiskRegisterContext.Provider
            value={{
              riskView,
              isScheduled: false,
              selectRiskView: setRiskView,
              showScheduledRisks: () => {}
            }}>
            {isOpen && <RiskView />}
            <AddRiskViewDrawer />
          </RiskRegisterContext.Provider>
        )}
      </Wrapper>
    </DrawerModal>
  )
}

export default LinkedFormViewModal
